import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { store } from "./app/store";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { OpenFeature, OpenFeatureProvider } from "@openfeature/react-sdk";
import { msalConfig } from "./authConfig";
import { initOpenFeatureProvider } from "./features/featureFlags/openFeatureProviders";

import "./css/app.min.css";
import "./css/appmediaqueries.min.css";
import "./css/variables.css";
import "./assets/fonts/tgicons/tg-icons.scss";
import "./scss/fonts.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import AnimatedRoute from "./components/AnimatedComponents/AnimatedRoute";
import AppNavigation from "./components/appNavBar/AppNavigation";
import ToastContainer from "./components/Toast/ToastContainer";
import NetworkStatusToastTrigger from "./features/networkStatus/NetworkStatusToastTrigger";
import NetworkStatusListener from "./features/networkStatus/NetworkStatusListener";
import { BrowserRouter } from "react-router-dom";
import "./features/featureFlags/flagContext";
import { BootstrapGate } from "./BootstrapGate";
import { AuthProvider } from "./hooks/useAuth";
import { DocumentTitleHelper } from "./components/DocumentTitleHelper/DocumentTitleHelper";

const appRoot = document.getElementById("root-dart");

/*
  MSW allows us to Mock API calls as part of the development process.
  It does not run in production builds.
 */
/*async function enableMocking() {
  if (import.meta.env.NODE_ENV !== "development") {
    return;
  }
  const { worker } = await import("./mocks/browser");
  return worker.start({
    onUnhandledRequest: "bypass",
  });
}*/
//await enableMocking();

const msalInstance = new PublicClientApplication(msalConfig);

async function initApp() {
  await msalInstance.initialize();

  await msalInstance.handleRedirectPromise().catch((err) => {
    console.warn("MSAL redirect handling warning:", err);
  });

  await initOpenFeatureProvider();
  window.OpenFeature = OpenFeature;

  // This function is used to debug the navigation behavior
  // setupHistoryMonitor();
  console.log("Dart_build<");
  const root = createRoot(appRoot);
  root.render(
    <React.StrictMode>
      <OpenFeatureProvider>
        <MsalProvider instance={msalInstance}>
          <Provider store={store()}>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <DocumentTitleHelper />
              <BootstrapGate>
                <AuthProvider>
                  <NetworkStatusListener />
                  <ToastContainer />
                  <NetworkStatusToastTrigger />
                  <AnimatedRoute />
                  <AppNavigation />
                </AuthProvider>
              </BootstrapGate>
            </BrowserRouter>
          </Provider>
        </MsalProvider>
      </OpenFeatureProvider>
    </React.StrictMode>,
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.register();

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

initApp();
